import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { PROGRAM_ADVERTISEMENTS_ITEMS } from '../constants/state'
import { ItemHeaderNoHtmlAccess, ItemWrapperAccess } from './ItemHelpersAccess'
import TranslationCont from '../General/TranslationCont'

const mapStateToProps = (state, ownProps) => ({
    item: getData(state, [PROGRAM_ADVERTISEMENTS_ITEMS, ownProps.id]),
})

const ItemAdvertisementAccess = ({
    item
}) => {
    const {title, link} = item

    if(!title || !link || !link.url) {
        return ''
    }

    return (
        <ItemWrapperAccess>
            <ItemHeaderNoHtmlAccess
                title={<TranslationCont id='advertisement'>Werbung</TranslationCont>}
            />

            <a href={link.url} target={'external' === link.destinationType ? '_blank'  : '_self'}>
                {title}
            </a>
        </ItemWrapperAccess>
    )
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ItemAdvertisementAccess)